import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { NgClass, NgIf } from "@angular/common";

@Component({
    selector: 'strava-sections-element',
    templateUrl: './stravaSectionsElement.component.html',
    styleUrls: ['./stravaSectionsElement.component.scss'],
    standalone: true,
    imports: [NgClass, TranslateModule, NgIf]
})

export class StravaSectionsElementComponent {

    @Input() stravaSection!: any;
    @Input() isSmall: boolean = false;

    @ViewChild('stravaElement') stravaElementRef!: ElementRef;

    stravaLinkClick(url: string) {
        window.open(url, "_blank");
    }

}

